// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__f9rg5","error":"style_error__La4Gm"};